import { FC } from 'react';

import { IconProps } from '../types';

const VegetarianIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M29.8807 19.6773C31.2884 20.471 33.158 20.5984 34.4438 19.3126C36.2958 17.4606 35.572 14.5016 33.7848 12.7143C35.6368 10.8624 35.6892 7.91226 33.902 6.12504C32.1148 4.33782 29.1646 4.39026 27.3128 6.2422C25.5256 4.45498 22.5663 3.73129 20.7144 5.58321C19.4419 6.85572 19.5542 8.75942 20.3255 10.1225"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2207 24.5841L8.18066 21.5439L8.75172 22.115"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6069 31.8232L13.8912 34.1075L13.3201 33.5364"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.957 22.3762L26.2643 26.6836L25.7258 26.1452"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3797 12.7455C10.1071 17.018 1.80015 31.1102 5.3684 34.6785C8.93665 38.2467 23.029 29.9398 27.3015 25.6673C31.574 21.3948 29.9345 17.2488 26.3663 13.6806C22.798 10.1123 18.6522 8.47295 14.3797 12.7455Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VegetarianIcon;
